import { Row } from "antd";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import useAxiosPost from "../../../hooks/useAxiosPost";
import TailSpinLoader from "../../Items/Loaders/TailSpinLoader";
import PendingVouchersTable from "../../Items/Table/PendingVouchersTable";
import "./../index.css";
const PendingVouchersComponent = () => {
  const navigate = useNavigate();
  const [pendingVouchers, setPendingVouchers] = useState<
    PendingDiscountVoucherProp[]
  >([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("discountVouchers/getPendingVouchers");

  useEffect(() => {
    postApiData({});
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      console.log({ data });
      setPendingVouchers(data || []);
    }
  }, [apiResponse]);

  return (
    <>
      {apiLoading === true ? (
        <TailSpinLoader />
      ) : (
        <>
          <Row gutter={[16, 16]}>
            <PendingVouchersTable vouchers={pendingVouchers} />
          </Row>
        </>
      )}
    </>
  );
};
export default PendingVouchersComponent;
